module.exports = "/wp-content/themes/onnit/script/cart/dist/hydratechInstantBg-dbde3bc3.jpg";